<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-md-12 mt-2" v-if="errors.length > 0">
        <div class="alert alert-danger mt-2">
          <ul style="margin-bottom: 0px">
            <li v-for="error in errors" :key="error">
              {{ error[0] }}
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-12 mx-auto mb-4 mt-3">
        <form @submit.prevent="onSubmit" enctype="multipart/form-data">
          <h5>{{ $t("pages.users.person") }}</h5>
          <hr />
          <div class="row">
            <div class="col-md-6">
              <label>{{ $t("pages.users.firstname") }} </label>
              <input type="text" v-model.trim="forms.firstname" class="form-control" required />
            </div>
            <div class="col-md-6">
              <label> {{ $t("pages.users.lastname") }} </label>
              <input type="text" v-model.trim="forms.lastname" class="form-control" required />
            </div>
          </div>
          <!-- <h5 class="mt-4">{{ $t("pages.users.contact") }}</h5>
          <hr /> -->
          <div class="row mt-4">
            <div class="col-md-6">
              <label>{{ $t("pages.users.mail") }}</label>
              <input type="email" v-model.trim="forms.email" class="form-control" required />
            </div>
            <div class="col-md-6 mt-2">
              <div class="custom-control custom-switch mt-4">
                <input type="checkbox" v-model="forms.actif" @click="toggle" class="custom-control-input"
                  id="customSwitch1" />
                <label class="custom-control-label" for="customSwitch1">{{
                  $t("pages.users.activeUser")
                  }}</label>
              </div>
            </div>
            <!-- <div class="col">
              <label>{{ $t("pages.users.phone") }} </label>
              <input v-model.trim="forms.phone" class="form-control" required />
            </div> -->

          </div>
          <!-- <div class="row mt- mb-4">
            <div class="col">
                <label for="adress">{{ $t("pages.users.adress") }}</label>
                <textarea
                  id="adress"
                  v-model="forms.address"
                  class="form-control"
                  rows="2"
                ></textarea>
              </div>
          </div> -->
          <h5 class="mt-4">{{ $t("pages.users.roles") }}</h5>
          <hr />
          <div class="row" v-if="gettingRoles">
            <loading :active.sync="gettingRoles" :can-cancel="false" loader="dots" color="rgb(20, 80, 144)" :width="100"
              :is-full-page="false">
            </loading>
          </div>
          <div class="row" v-else>
            <div class="col-4" v-for="(r, index) in roles" :key="index">
              <div class="form-check mt-2">
                <input class="form-check-input" v-model="role.role_id" type="checkbox" :value="r.id" :id="r.name" />
                <label class="form-check-label" :for="r.name">
                  {{ r.name }}
                </label>
              </div>
            </div>
          </div>
          <div class="mt-4 mb-3">
            <div class="row">
              <div class="col-12 text-left">
                <button v-if="this.isLoading === false" type="submit" class="btn btn-primary mr-2"
                  :disabled="gettingRoles">
                  {{ $t("pages.users.save") }}
                </button>
                <button class="btn btn-primary mr-2" type="button" v-else disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {{ $t("pages.users.saving") }}
                </button>
                <router-link :to="{ name: 'Users' }" class="btn btn-light">{{ $t("pages.users.cancel") }}
                </router-link>
              </div>
              <div class="col-md-4"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loading from "vue-loading-overlay";
import PageHeader from "@/components/page-header";
import { mapActions, mapState } from "vuex";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Utilisateurs",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loading,
  },
  data() {
    return {
      roles: [],
      role: {
        role_id: [],
      },
      title: "pages.users.create",

      forms: {
        email: "",
        firstname: "",
        lastname: "",
        middlename: "-",
        phone: "-",
        address: "-",
        actif: true,
        picture: "",
        role: {
          role_id: [],
        },
      },
      isLoading: false,
      initializing: false,
      gettingRoles: false,
      file: "",
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.user.errors,
    }),
  },
  methods: {
    ...mapActions(["createUser", "getRoles"]),
    onSubmit() {
      if (this.$can("create", "users")) {
        this.isLoading = true;
        let user = {
          firstname: this.forms.firstname,
          middlename: this.forms.middlename,
          lastname: this.forms.lastname,
          email: this.forms.email,
          address: this.forms.address,
          phone: this.forms.phone,
          actif: this.forms.actif,
          picture: this.forms.picture,
          roles: this.role,
        };
        this.createUser(user).then((created) => {
          if (created === true) {
            this.isLoading = false;
            this.$toasted.success(this.$t('pages.users.actions.created'));
            this.$router.push({ name: "Users" });
          } else {
            this.isLoading = false;
            this.$toasted.error(this.$t('pages.unauthorized.error_0'));
          }
        });
      } else {
        this.$toasted.error(this.$t('pages.unauthorized.forbidden'));
      }
    },

    handleFileUpload(event) {
      this.forms.picture = event.target.files[0];
    },

    toggle: function () {
      this.actif = !this.actif;
    },

    cancel() {
      this.forms = {
        email: "",
        firstName: "",
        name: "",
        phone: "",
        address: "",
        actif: false,
        picture: "",
      };
    },
  },
  mounted() {
    this.$store.commit("CLEAR_ERROR_STATE");
  },
  created() {
    if (this.$can("create", "users")) {
      this.gettingRoles = true;
      this.getRoles()
        .then((response) => {
          if (response.status == 200) {
            this.roles = response.data;
            this.gettingRoles = false;
          } else {
            this.gettingRoles = false;
          }
        })
        .catch((err) => {
          this.gettingRoles = false;
          console.log(err);
        });
    }
  },
};
</script>

<style lang="scss" scoped>
h4 {
  opacity: 0.9;
}
</style>


